import { Component, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Statement } from '../../../../core/models/chat.models';

interface TextPart {
  type: 'text' | 'reference';
  content: string;
  refIndex?: number;
  statement?: Statement;
  tooltipText?: string;
}

@Component({
  selector: 'app-message-with-refs',
  imports: [CommonModule],
  templateUrl: './message-with-refs.component.html',
  styleUrls: ['./message-with-refs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageWithRefsComponent implements OnChanges {
  @Input() text: string = '';
  @Input() statements: Statement[] = [];
  @Output() referenceClick = new EventEmitter<Statement>();

  parsedParts: TextPart[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text'] || changes['statements']) {
      this.parsedParts = this.parseText();
    }
  }

  private parseText(): TextPart[] {
    if (!this.text) return [];

    const parts: TextPart[] = [];
    const refPattern = /\[(\d+)\]/g;
    let lastIndex = 0;
    let match;

    while ((match = refPattern.exec(this.text)) !== null) {
      if (match.index > lastIndex) {
        parts.push({
          type: 'text',
          content: this.text.substring(lastIndex, match.index)
        });
      }

      const refNum = parseInt(match[1], 10);
      const statement = this.statements[refNum - 1];

      parts.push({
        type: 'reference',
        content: match[0],
        refIndex: refNum,
        statement: statement,
        tooltipText: this.getTooltipText(statement)
      });

      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < this.text.length) {
      parts.push({
        type: 'text',
        content: this.text.substring(lastIndex)
      });
    }

    return parts;
  }

  handleRefClick(statement: Statement | undefined): void {
    if (statement) {
      this.referenceClick.emit(statement);
    }
  }

  // Plain text only — statement text comes from ingested documents, so it must
  // never be rendered as HTML (see PR #12 review).
  private getTooltipText(statement: Statement | undefined): string {
    if (!statement) return '';
    return statement.text || statement.statement || '';
  }
}
